import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import TableTemplete from "../Helper/TableTemplet/TableTemplet";
import { getLevelTiers, updateLevelTiersInDB } from "./LevelTiersUtils";

const columns = [
  {
    id: "product_type",
    label: "Product type",
    // minWidth: 150,
    edit: false,
    type: "text",
  },
  { id: "weight_min", label: "Weight min", edit: true, type: "number", 
  // minWidth: 80 
},
  { id: "weight_max", label: "Weight max", edit: true, type: "number", 
  // minWidth: 80
 },
  { id: "unit", label: "Unit", edit: true, type: "text",
  //  minWidth: 50 
  },
  {
    id: "longest_side_min",
    label: "Longest side min",
    edit: true,
    type: "number",
    // minWidth: 130
  },
  {
    id: "longest_side_max",
    label: "Longest side max",
    edit: true,
    type: "number",
    // minWidth: 130
  },
  {
    id: "median_side_min",
    label: "Median side min",
    edit: true,
    type: "number",
    // minWidth: 130
  },
  {
    id: "median_side_max",
    label: "Median side max",
    edit: true,
    type: "number",
    // minWidth: 130
  },
  {
    id: "shortest_side_min",
    label: "Shortest side min",
    edit: true,
    type: "number",
    // minWidth: 130
  },
  {
    id: "shortest_side_max",
    label: "Shortest side max",
    edit: true,
    type: "number",
    // minWidth: 130
  },
  {
    id: "length_girth_min",
    label: "Length girth min",
    edit: true,
    type: "number",
    // minWidth: 130
  },
  {
    id: "length_girth_max",
    label: "Length girth max",
    edit: true,
    type: "number",
    // minWidth: 130
  },
];

const LevelTiers = () => {
  const dispatch = useDispatch();
  let levelTiersData = useSelector((state: any) => state.tiers.level_tiers);

  useEffect(() => {
    if (!levelTiersData.length) getLevelTiers(dispatch);
  }, []);

  const saveChangesInDB = async (item) => {
    updateLevelTiersInDB(dispatch, item);
  };
  
  return (
    <div>
      <h2>Calculate Level Tiers</h2>
      <TableTemplete
        columns={columns}
        data={levelTiersData}
        saveChangesInDB={saveChangesInDB}
      ></TableTemplete>
    </div>
  );
};
export default LevelTiers;
